import React, { useEffect, useState,useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import $ from 'jquery';

const EmailVerification = () => {
  debugger;
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');
  const calledOnce = useRef(false);

  useEffect(() => {
    if (calledOnce.current) return; // Prevent second call in Strict Mode
    calledOnce.current = true;

     if (!token) {
      setStatus('error');
      setMessage('Verification token missing');
      return;
    }

    $.ajax({
      url: `${apiBaseUrl}/Auth/email-verification`,
      type: 'PATCH',
      contentType: 'application/json',
      data: JSON.stringify({ token }), // <-- Proper body format
      success: function (response) {
        if (response.success) {
          setStatus('success');
          setMessage('Your email has been successfully verified!');
        } else {
          setStatus('error');
          setMessage(response.data?.errorMessage || 'Verification failed.');
        }
      },
      error: function () {
        setStatus('error');
        setMessage('Something went wrong while verifying your email.');
      }
    });

  }, []);

    return (
    <div className="d-flex justify-content-center align-items-center bg-light" style={{ minHeight: '60vh' }}>
        <div className="text-center p-4 bg-white rounded shadow-sm" style={{ width: '100%', maxWidth: '350px' }}>
        <h4 className="mb-3">Email Verification</h4>

        {status === 'loading' && (
            <p className="text-muted small">Please wait, verifying your email...</p>
        )}

        {status !== 'loading' && (
            <p className={status === 'success' ? 'text-success fw-semibold' : 'text-danger fw-semibold'}>
            {message}
            </p>
        )}
        </div>
    </div>
    );

};

export default EmailVerification;
